import { ChangeEvent, FC, useState } from 'react';

import Button from 'components/_core/Button';
import SunshineModal from 'components/_core/SunshineModal';
import { useModal } from 'components/ModalProvider/hooks';
import useToast from 'components/ToastProvider/useToast';
import ClientContactForm from 'features/Work/components/ClientContactForm';

import { useClientModalContext } from '../../../../components/Modals';
import { ClientModalType } from '../../../../components/Modals/types';
import { useUpdateClientContact } from '../../../../hooks/useUpdateClientContact';
import { Contact } from '../../types';
import locales from './locales';

interface EditContactModalProps {
  contact: Contact;
}

const EditContactModal: FC<EditContactModalProps> = ({ contact }) => {
  const { hideModal, showModal } = useModal();
  const { showToast } = useToast();
  const { setContact } = useClientModalContext();

  const [formContact, setFormContact] = useState(contact);

  const { loading, updateClientContact } = useUpdateClientContact(
    contact.clientId,
  );

  const onChange = (e: ChangeEvent<HTMLInputElement>) =>
    setFormContact({
      ...formContact,
      [e.target?.name]: e.target?.value,
    });

  const onSubmit = async () => {
    const { data } = await updateClientContact(formContact);

    const updatedContact = data?.updateClientContact?.clientContact;

    showToast({
      message: locales.formatString(
        locales.successMessage,
        updatedContact
          ? `${updatedContact.firstName} ${updatedContact.lastName}`
          : '',
      ) as string,
      title: locales.successTitle,
      type: 'success',
    });

    hideModal();
  };

  return (
    <SunshineModal isOpen onClose={hideModal}>
      <ClientContactForm
        clientContact={formContact}
        loading={loading}
        modalTitle={locales.modalTitle}
        onChange={onChange}
        onSubmit={onSubmit}
        submitButtonText={locales.saveChanges}
      >
        <Button
          onClick={() => {
            setContact({
              ...contact,
              clientContactId: contact.clientContactId ?? '',
              clientId: contact.clientId ?? '',
            });
            showModal(ClientModalType.DeleteContact);
          }}
          variant="danger"
        >
          {locales.deleteContact}
        </Button>
      </ClientContactForm>
    </SunshineModal>
  );
};

export default EditContactModal;
